import { useEffect, memo, Fragment, useState } from "react";

import { Link } from "react-router-dom";

import VerticalNav from "./vertical-nav";
import Logo from "../../components/logo";

import Scrollbar from "smooth-scrollbar";

import * as SettingSelector from "../../../../store/setting/selectors";

import { useSelector } from "react-redux";

const Sidebar = memo((props) => {
  const sidebarColor = useSelector(SettingSelector.sidebar_color);
  const [sideType, setSideType] = useState(false);

  useEffect(() => {
    Scrollbar.init(document.querySelector("#my-scrollbar"));

    window.addEventListener("resize", () => {
      const tabs = document.querySelectorAll(".nav");
      if (window.innerWidth < 1025) {
        Array.from(tabs, (elem) => {
          if (
            !elem.classList.contains("flex-column") &&
            elem.classList.contains("nav-tabs") &&
            elem.classList.contains("nav-pills")
          ) {
            elem.classList.add("flex-column", "on-resize");
          }
          return elem.classList.add("flex-column", "on-resize");
        });
      } else {
        Array.from(tabs, (elem) => {
          if (elem.classList.contains("on-resize")) {
            elem.classList.remove("flex-column", "on-resize");
          }
          return elem.classList.remove("flex-column", "on-resize");
        });
      }
    });
  });

  return (
    <Fragment>
      <aside
        className={`${sidebarColor} sidebar sidebar-default ${
          props.isWideMenuPage ? "sidebar-menu-wide" : ""
        }`}
        data-sidebar="responsive"
      >
        <div className="sidebar-header ps-0">
          <Link to="/shops" className="navbar-brand">
            <Logo />
          </Link>
        </div>
        <div
          className="pt-0 sidebar-body data-scrollbar"
          data-scroll="1"
          id="my-scrollbar"
        >
          {/* sidebar-list class to be added after replace css */}
          <div className="sidebar-list navbar-collapse mb-5 pb-5" id="sidebar">
            <VerticalNav />
          </div>
        </div>
      </aside>
    </Fragment>
  );
});

Sidebar.displayName = "Sidebar";
export default Sidebar;
